import { Program, ReportingPeriodType, TClientId, TProgramId, TReportingPeriodTypeId } from 'src/lib/models';
import { DateString } from '../types';

export type TClientReportingPeriodId = number;

export interface ClientReportingPeriod {
  id: TClientReportingPeriodId;
  client_id: TClientId;
  program_id: TProgramId;
  program?: Program;
  reporting_period_type: ReportingPeriodType;
  reporting_period_type_id: TReportingPeriodTypeId;
  start_reporting_quarter: DateString;
  end_reporting_quarter: DateString;
  is_finalized: boolean;
  is_client_locked: boolean;
  created_at: DateString;
  updated_at?: DateString;
}
